export default function FilterItem({active = false, onClick, children}) {
    return (
        <button
            className={`inline-flex items-center border text-sm py-3 px-4 rounded-full cursor-pointer ${active ? 'bg-black text-white hover:bg-black/80 border-black/0' : 'text-black/40 border-black/15 hover:text-black/70 hover:border-black/40'} transition-all duration-200`}
            onClick={onClick}
        >
            {/* todo: remove mx-3 */}
            <div className="mx-3">
                {children}
            </div>
        </button>
    )
}
